import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import config from "./config";

const SiteSelection = () => {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [clock, setClock] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  // Load sites or validate GUID
  useEffect(() => {
    const guid = new URLSearchParams(location.search).get("guid");
    if (guid) {
      fetch(`${config.apiUrl}/validateGuid?guid=${guid}`)
          .then((r) => { if (!r.ok) throw new Error(); return r.json() })
          .then((data) => {
            if (data.places?.length) navigate(`/enter-car?guid=${guid}`);
            else throw new Error();
          })
          .catch(() => {
            setError("GUID לא תקין. אנא נסו שנית.");
            setIsLoading(false);
          });
    } else {
      fetch(`${config.app.serverUrl}/sites`)
          .then((r) => { if (!r.ok) throw new Error(); return r.json() })
          .then((data) => {
            setSites(data.sites.filter((s) => s.active));
            setIsLoading(false);
          })
          .catch(() => {
            setError("תקלה בטעינת האתרים. אנא נסו שנית.");
            setIsLoading(false);
          });
    }
  }, [location.search, navigate]);

  // Clock
  useEffect(() => {
    const iv = setInterval(() => {
      setClock(new Date().toLocaleTimeString("en-GB"));
    }, 1000);
    return () => clearInterval(iv);
  }, []);

  const handleContinue = () => {
    if (!selectedSite) {
      setError("אנא בחרו אתר מהרשימה.");
    } else {
      navigate(`/enter-car?guid=${selectedSite}`);
    }
  };

  return (
      <div
          style={{
            position: "relative",
            width: "100vw",      // ← full viewport width
            height: "100vh",     // ← full viewport height
            margin: 0,
            background: "#FFFFFF",
            overflow: "hidden",
            direction: "rtl",
          }}
      >
        {/* Logo */}
        <img
            src="/logo.png"
            alt="Blue Parking"
            style={{
              display: "block",
              width: 300,
              margin: "72px auto 48px",
            }}
        />

        {isLoading ? (
            <p
                style={{
                  textAlign: "center",
                  color: "#00427C",
                  fontSize: 16,
                }}
            >
              טוען נתונים…
            </p>
        ) : (
            <>
                {error && (
                    <p
                        style={{
                            textAlign: "center",
                            color: "#C00",
                            fontSize: 14,
                            margin: "0 16px 24px",
                        }}
                    >
                        {error}
                    </p>
                )}

                {/* Dropdown */}
                <div
                    style={{
                        width: 333,
                        height: 48,
                        margin: "0 auto 24px",
                        position: "relative",
                        border: "1px solid #0098CF",
                        borderRadius: 8,
                        overflow: "hidden",
                        background: "#FFF",
                    }}
                >
                    <select
                        value={selectedSite}
                        onChange={(e) => setSelectedSite(e.target.value)}
                        style={{
                            // — Hide the native arrow
                            appearance: "none",
                            WebkitAppearance: "none",
                            MozAppearance: "none",

                            // — Your dropdown styling
                            width: "100%",
                            height: "100%",
                            padding: "0 40px 0 16px",      // extra right padding for our custom arrow
                            fontSize: 16,
                            color: "#00427C",
                            backgroundColor: "transparent",
                            border: "none",
                            outline: "none",
                            cursor: "pointer",
                            textAlign: "right",

                            // — Custom arrow as a background image, positioned on the right
                            backgroundImage: `url("data:image/svg+xml;utf8,
      <svg xmlns='http://www.w3.org/2000/svg' width='12' height='8'>
        <path d='M1 1l5 6 5-6' stroke='%23009ECF' stroke-width='2' fill='none'/>
      </svg>"
    )`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "right 16px center",
                        }}
                    >
                        <option value="">בחרו מיקום חניון</option>
                        {sites.map((s) => (
                            <option key={s.lane_guid} value={s.lane_guid}>
                                {s.displayName}
                            </option>
                        ))}
                    </select>


                    {/* arrow */}
                    <div
                        style={{
                            position: "absolute",
                            right: 16,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: 12,
                            height: 8,
                            backgroundImage:
                                `url("data:image/svg+xml;utf8,` +
                                `<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8'>` +
                                `<path d='M1 1l5 6 5-6' stroke='%23009ECF' stroke-width='2' fill='none'/>` +
                                `</svg>")`,
                            backgroundRepeat: "no-repeat",
                            pointerEvents: "none",
                        }}
                    />
                </div>

                {/* Continue button */}
                <button
                    onClick={handleContinue}
                    style={{
                        display: "block",
                        width: 333,
                        height: 45,
                        margin: "0 auto 24px",
                        border: "none",
                        borderRadius: 10,
                        background:
                            "linear-gradient(90deg, #DEF7FF -11.26%, #0098CF 34.16%, #173E6B 100%)",
                        boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                        color: "#FFF",
                        fontSize: 18,
                        cursor: "pointer",
                    }}
                >
                    המשך
                </button>

                {/* Footer */} <img
                src="/bIcon.jpeg"
                alt=""
                style={{
                    position: "absolute",
                     marginTop: "5%",                     // nudge down from the top of footer
                    left: "50%",
                    transform: "translateX(-50%) rotate(-45deg)",
                    width: "100vh",                  // match your design scale
                    opacity: 0.05,               // very faint
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />
                <footer
                    style={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        height: 150,                  // give it enough room for the icon
                        overflow: "hidden",
                        borderTopLeftRadius: 22,
                        borderTopRightRadius: 22,
                        background: "rgba(0,152,207,0.23)",
                        boxShadow: "0px 4px 13px rgba(8,25,40,0.22)",
                    }}
                >


                    <div
                        style={{
                            width: 333,
                            margin: "0 auto",
                            display: "flex",
                            justifyContent:"center",
                            alignItems: "center",
                            marginTop: "20px",
                            flexDirection: "column",
                            gap: 6,
                        }}
                    >
                        <p
                            style={{
                                margin: 0,
                                color: "#00427C",
                                fontSize: 14,
                            }}
                        >
                            שעה נוכחית:{" "}
                            <span style={{ fontWeight: 600}}>
                  {clock}
                </span>
                        </p>
                        <p
                            style={{
                                margin: 0,
                                color: "#00427C",
                                fontSize: 12,
                                opacity: 0.8,
                            }}
                        >
                            © BluePT {new Date().getFullYear()}
                        </p>
                    </div>
                </footer>
            </>
        )}
      </div>
  );
};

export default SiteSelection;
